import { render, staticRenderFns } from "./TransactionChargeBack.vue?vue&type=template&id=1716155d&functional=true&"
import script from "./TransactionChargeBack.vue?vue&type=script&lang=ts&"
export * from "./TransactionChargeBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports